import Layout from "../../common/layout";
import {Alert, Col, Row} from "react-bootstrap";
import RequestList from "./request-list";
import {useEffect, useState} from "react";
import useCallBackend from "../../hooks/use-call-backend";
import Error from "../../common/error";
import {PendingRequestDetails} from "../../modal/pending-request-details";
import RequestDetails from "./request-details";
import Loading from "../../common/loading";

const ActivationRequests:React.FC = () => {
    const {isLoading: isLoadingReqDetails, error: errorGettingReqDetails, invokeBackend} = useCallBackend();
    const [requestId, setRequestId] = useState<number | null>(null);
    const [requestDetails, setRequestDetails] = useState<PendingRequestDetails | null>(null);
    const [refreshList, setRefreshList] = useState(false);

    useEffect(() => {
        if(refreshList){
            setRefreshList(false);
        }
    }, [refreshList])

    const handleRequestDetailsResponse = (pendingRequestDetails: PendingRequestDetails) => {
        setRequestDetails(pendingRequestDetails);
    }

    const handleRequestSelection = (selectedId: number):void => {
        setRequestId(selectedId);
        setRequestDetails(null); //reset data
        invokeBackend({url: "/api/vapActivation/getPendingRequestDetails/" + selectedId}, handleRequestDetailsResponse);
    }

    const handleResetSelectedRequest = () => {
        setRequestDetails(null);
        setRefreshList(true);
    }

    return <Layout>
        <Row>
            <Col xs={12} md={3} className="mt-3">
                {!refreshList && <RequestList handleRequestSelection={handleRequestSelection} />}
            </Col>
            <Col xs={12} md={9} className="mt-3">
                {isLoadingReqDetails && <Loading />}
                {errorGettingReqDetails && <Error message={errorGettingReqDetails} />}
                {requestDetails && <RequestDetails requestId={requestId} pendingReqDetails={requestDetails} resetView={handleResetSelectedRequest} />}
                {!isLoadingReqDetails && !errorGettingReqDetails && !requestDetails && <Alert variant="primary" >No Request Selected.</Alert>}
            </Col>
        </Row>
    </Layout>;
}

export default ActivationRequests;